<template lang="pug">
.benjamin-home
  section.stat-bar
    StatBar

  .outer-wrapper
    .page-container
      TitleBlock

    AnimatedBar

    Content
</template>

<style>
:root {
    --wrapper-outer-width: 1600px;
    --wrapper-inner-width: 960px;
    --wrapper-padding: 1rem;
    --breakout-width: 1264px;
    --gap-700: min(3rem, 10vw);
    --gap-900: 4rem;

    @media (min-width: 480px) {
        --wrapper-padding: 2rem;
    }
}

html {
    scroll-behavior: smooth;
    scroll-padding: 4rem;
}

.benjamin-home {
    padding-bottom: min(5rem, 5vw);
}

.outer-wrapper {
    max-width: calc(var(--wrapper-outer-width) + 2 * var(--wrapper-padding));
    padding-inline: var(--wrapper-padding);
    margin-inline: auto;
}

.inner-wrapper {
    max-width: var(--wrapper-inner-width);
    margin-inline: auto;
}

.breakout {
    max-width: var(--breakout-width);
    margin-inline: auto;
}

.page-container {
    margin-block: var(--gap-900);
}

.grid {
    display: grid;
}

.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}

.gap-200 {
    gap: 0.5rem;
}

.gap-400 {
    gap: 1rem;
}

.gap-700 {
    gap: var(--gap-700);
}
</style>

<script>
import StatBar from "../components/home/StatBar";
import TitleBlock from "../components/home/TitleBlock";
import AnimatedBar from "../components/home/AnimatedBar";
import Content from "../components/home/Content";

export default {
    name: "Home",
    components: {
        StatBar,
        TitleBlock,
        AnimatedBar,
        Content,
    },
};
</script>
